import gql from 'graphql-tag';
import { THREAD_REPLY_FRAGMENT } from '@/graphql/queries/thread-reply-queries';

export const ALL_FORUM_TAGS_QUERY = gql`
query tags {
  forumTags {
    id
    name
    description
  }
}`;

export const GET_SINGLE_THREAD_QUERY = gql`
${THREAD_REPLY_FRAGMENT}
query thread($id: NexusId, $slug: String) {
  thread(id: $id, slug: $slug) {
    name
    body
    id
    isClosed
    isPendingModeration
    insertedAt
    replies {
      ...ThreadReplyFragment
      replies {
        ...ThreadReplyFragment
      }
    }
    tags{
      name
      id
    }
    user {
      id
      username
      avatar {
        thumb
      }
      insertedAt
    }
    is_featured
    last_active_date
    is_subscribed
    seo {
      canonical
      metaRobotsNoindex
      metadesc
      metakeywords
      opengraphDescription
      opengraphImage
      opengraphTitle
      title
      twitterDescription
      twitterImage
      twitterTitle
    }
  }
}
`;

export const THREAD_TEASER_QUERY = gql`
query threadTeaser($id: NexusId) {
  threadTeaser(id: $id) {
    id
    title
    name
    slug
    body
    date
    author {
      id
      username
      avatar {
        thumb
      }
    }
    tags {
      id
      name
    }
    lastActiveAt
    commentCount
  }
}
`;
